import { BaseError } from "make-error";
import { Error } from "grpc-web";
import { grpc } from "@tsg/1st-grpc-web-rh360";

export class FirstApiError extends BaseError implements Error {
  public readonly code: grpc.Status;
  public readonly message: string;

  public constructor(message: string, code: number) {
    super(message);

    this.code = code;
    this.message = message;
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function interceptErrors(grpcClient: any): void {
  const originalRpcCall = grpcClient.client_.rpcCall;
  grpcClient.client_.rpcCall = async (
    method,
    request,
    metadata,
    methodInfo,
    callback
  ) => {
    return await originalRpcCall.call(
      grpcClient,
      method,
      request,
      metadata,
      methodInfo,
      (err, response) => {
        if (err) {
          callback(new FirstApiError(err.message, err.code), null);
          return;
        }
        callback(null, response);
      }
    );
  };
}
